import { render, staticRenderFns } from "./ServicereceiptView.vue?vue&type=template&id=a95a9a2c&scoped=true"
import script from "./ServicereceiptView.vue?vue&type=script&lang=js"
export * from "./ServicereceiptView.vue?vue&type=script&lang=js"
import style0 from "./ServicereceiptView.vue?vue&type=style&index=0&id=a95a9a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95a9a2c",
  null
  
)

export default component.exports